import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { config } from '../config.ts';

/**
 * OIDC client for Keycloak: Authorization Code + PKCE (S256, always on in oidc-client-ts).
 * Tokens are kept in localStorage, so the sign-in survives new tabs and browser restarts for as
 * long as the refresh token lives (the realm's SSO session: 7 days idle, 30 days max). Renewal uses
 * the refresh token rather than a hidden iframe, so it keeps working when third-party cookies are
 * blocked.
 */
export const userManager = new UserManager({
  authority: config.oidcAuthority,
  client_id: config.oidcClientId,
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 45,
  loadUserInfo: false,
  monitorSession: false,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

export interface SignInState {
  /** In-app path to return to after the callback. */
  returnTo?: string;
}
